module.exports = __webpack_public_path__ + "static/media/home1.ce3c4859.png";